import ActionIcon from './ActionIcon';
import Badge from './Badge';
import Breadcrumbs from './Breadcrumbs';
import Button from './Button';
import Checkbox from './Checkbox';
import DateInput from './DateInput';
import Divider from './Divider';
import Input from './Input';
import InputWrapper from './InputWrapper';
import MonthPickerInput from './MonthPickerInput';
import MultiSelect from './MultiSelect';
import Pagination from './Pagination';
import Paper from './Paper';
import PillsInput from './PillsInput';
import Select from './Select';
import Table from './Table';
import Tabs from './Tabs';
import TextInput from './TextInput';
import ThemeIcon from './ThemeIcon';

export default {
  ActionIcon,
  Badge,
  Breadcrumbs,
  Button,
  Checkbox,
  DateInput,
  Divider,
  Input,
  InputWrapper,
  MonthPickerInput,
  MultiSelect,
  Paper,
  PillsInput,
  Select,
  Table,
  Tabs,
  TextInput,
  ThemeIcon,
  Pagination,
};
